module.exports = __webpack_public_path__ + "static/media/logo.3f752f8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 176
// module chunks = 3